import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>
                                                The research shows that we can influence our own momentum to
                                                complete a task, reducing fatigue
                                                and focusing on success. This helps to stave off ‘the wall’
                                                which we will all feel at some time and stay
                                                focused on the task to hand. This tool is all about <span
                                                className="brown brownbold">how to maintain momentum until the completion
of every task </span>and will help you to take ownership of situations and understand how you can keep
                                                going to the finish.
                                            </p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>PHYSICS AND TASK LEADERSHIP
                                            </div>
                                            <div className="border_subtitle">‘How to maintain momentum until the
                                                completion of every task’.
                                            </div>
                                            <p>Let’s consider this statement by applying some basic physics:</p>
                                            <p>Momentum refers to the <span className="subtiltereg"> ‘quantity of motion that an object possesses’;</span> in
                                                other words, momentum
                                                refers to the <span className="subtiltereg">‘amount of “stuff” that is moving and how fast the “stuff” is moving’.</span> Any
                                                mass that
                                                is in motion has momentum and the implication of this idea is
                                                that people also have momentum.
                                                Is this really the case though?</p>
                                            <p>People can have momentum too. For example, it is a well known
                                                phenomenon in sport that the
                                                ‘momentum’ can be with a particular team or individual, and this
                                                is generally assumed to be a
                                                good predictor of improved performance. This is attributed to
                                                the fact that the agent in question
                                                has developed a temporary ‘winning habit’ and this is giving
                                                them extra motivation and confidence,
                                                that the opponent no longer has.</p>
                                            <p>Especially important to the definition of momentum is <span
                                                className="subtiltereg">‘energy’.</span> Here the laws of
                                                physics also
                                                apply. In brief, the law of conservation of energy states
                                                that <span className="subtiltereg">‘energy cannot be created or
destroyed, it can only be changed from one form to another’,</span> as when electrical energy
                                                is changed into heat energy – or for our purposes, when an idle
                                                employee changes into an
                                                active employee!</p>
                                            <p>So, for the purposes of our discussion, let’s imagine ourselves
                                                as existing in a type of energy field
                                                where <span className="subtiltereg">our movement towards task completion is influenced by driving and restraining forces,
respectively.</span> In terms of momentum, driving forces include those factors that push employees
                                                towards task completion, whereas restraining forces inhibit the
                                                employee’s progress towards
                                                task completion. The exact nature of these forces will become
                                                clearer as you continue reading.</p>
                                            <p>The following section delves a little deeper into the concept of
                                                an energy field. You might find it
                                                useful to refer to the Energy field model that appears
                                                later.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>YOUR ENERGY FIELD DECIPHERED
                                            </div>
                                            <p>The idea of driving and restraining forces originated from the
                                                work of Kurt Lewin on Force Field
                                                Analysis.<a className="superscripttext"
                                                            href="further_info.php?course=300"><sup>4</sup></a> He
                                                stated that when the sum of driving forces equals the sum of
                                                restraining forces, a
                                                so-called state of equilibrium is achieved. Equally, when one
                                                force is stronger than the other, this
                                                unbalances the equilibrium:</p>

                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/work.png')}
                                                    alt=""/>

                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}